import { SECTION_DEFINITIONS } from "../constants";

export function adaptSectionTitleSettingsPayload(
	current: SectionTitleSetting[],
	initial: SectionTitleSetting[]
): CMSSetting[] {
	const payload: CMSSetting[] = [];

	for (const curr of current) {
		const init = initial.find((s) => s.key === curr.key);
		const def = SECTION_DEFINITIONS.find((d) => d.key === curr.key);
		if (!def || !init) continue;

		if (curr.title !== init.title) {
			payload.push({ name: def.titleSettingName, value: curr.title });
		}
		if (curr.shown !== init.shown) {
			payload.push({ name: def.shownSettingName, value: curr.shown });
		}
	}

	return payload;
}
